import React, { useState, useEffect, Suspense } from "react";
import Grid from "@mui/material/Grid";
//import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { setState } from "./editScenarioNewSlice";
import './ScenarioEdit.css'
import { FixedSizeList as List } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import AutoSizer from 'react-virtualized-auto-sizer';
import CustomButton from "../../../components/ui/CustomButton";

const addBtnText = "Add >";
const addAllBtnText = "Add All >>";
const remBtnText = "< Remove";
const remAllBtnText = "<< Remove All";

function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferList({
    leftList,
    rightList,
    leftState,
    rightState,
    isCustomer
}) {
    const [checked, setChecked] = useState([]);
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [countLeft, setCountLeft] = useState(0);
    const [countRight, setCountRight] = useState(0);
    const [isAscByNameLeft, setAscByNameLeft] = useState(false);
    const [isAscByNameRight, setAscByNameRight] = useState(false);
    const [isAscByNumberLeft, setAscByNumberLeft] = useState(false);
    const [isAscByNumberRight, setAscByNumberRight] = useState(false);
    const [selectionStart, setSelectionStart] = useState(null);
    const [startIndex, setStartIndex] = useState(null);
    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [boxWidth, setBoxWidth] = useState(24);
    const isTab = useMediaQuery("(max-width: 800px)");
    const [listHeight, setlistHeight] = useState(46);

    useEffect(() => {
        const updateZoomLevel = () => {
            const zoom = window.devicePixelRatio || 1;
            if (zoom <= 1) {
                let l = isTab ? 25 : 29;
                setBoxWidth(l);
                setlistHeight(46);
            } else if (zoom > 1 && zoom <= 1.25) {
                setBoxWidth(isTab ? 19 : 26);
                setlistHeight(60);
            } else if (zoom > 1.25 && zoom < 1.5) {
                let l = isTab ? 20 : 24;
                setBoxWidth(l);
                setlistHeight(70);
            } else if (zoom == 1.5) {
                setBoxWidth(isTab ? 19.5 : 22);
                setlistHeight(95);
            } else if (zoom > 1.5 && zoom <= 2) {
                setBoxWidth(isTab ? 18 : 23);
                setlistHeight(70);
            } else if (zoom > 2) {
                setBoxWidth(isTab ? 90 : 90);
                setlistHeight(70);
            }
        }
        updateZoomLevel();
        window.addEventListener('resize', updateZoomLevel);
        return () => {
            window.removeEventListener('resize', updateZoomLevel);
        }
    }, [window.devicePixelRatio, isTab]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (leftList?.length >= 0) {
            setLeft(leftList);
        }
        if (rightList?.length >= 0) {
            setRight(rightList);
        }
    }, [leftList, rightList]);

    useEffect(() => {
        setCountLeft(left.length);
        setCountRight(right.length);
    }, [left, right]);

    const handleToggle = (event, index, value, side) => {
        setTimeout(() => {
            if (event.detail === 2) {
                setChecked([]);
                return;
            }
            if (event.shiftKey && startIndex !== null) {
                const start = Math.min(startIndex, index);
                const end = Math.max(startIndex, index);
                let a = [];
                if (side === "left") {
                    a = JSON.parse(JSON.stringify(left));
                } else {
                    a = JSON.parse(JSON.stringify(right));
                }
                const newSelectedItems = a.slice(start, end + 1);
                console.log(newSelectedItems);

                const newChecked = [];
                for (let i = 0; i < newSelectedItems.length; i++) {
                    const currentIndex = newChecked.findIndex((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    let item = [];
                    if (side === "left") {
                        item = left.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    } else {
                        item = right.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    }

                    if (currentIndex === -1) {
                        newChecked.push(item);
                    } else {
                        newChecked.splice(currentIndex, 1);
                    }

                }
                setChecked(newChecked);
            }
            else {
                const currentIndex = checked.indexOf(value);
                console.log(event)
                const newChecked = [...checked];

                if (currentIndex === -1) {
                    newChecked.push(value);
                    setStartIndex(index)
                } else {
                    newChecked.splice(currentIndex, 1);
                    setStartIndex(null)
                }

                setChecked(newChecked);
            }

        }, 300);
    };
    const handleMouseDown = (e, index) => {
        e.preventDefault();
        setSelectionStart(index);
    };

    const handleMouseMove = (e, side, index) => {
        if (selectionStart !== null && e.shiftKey) {
            const start = Math.min(selectionStart, index);
            const end = Math.max(selectionStart, index);
            let a = [];
            if (side === "left") {
                a = JSON.parse(JSON.stringify(left));
            } else {
                a = JSON.parse(JSON.stringify(right));
            }
            const newSelectedItems = a.slice(start, end + 1);
            console.log(newSelectedItems);
            if (newSelectedItems.length > 0 && newSelectedItems.length < 10) {
                const newChecked = [];
                for (let i = 0; i < newSelectedItems.length; i++) {
                    const currentIndex = newChecked.findIndex((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    let item = [];
                    if (side === "left") {
                        item = left.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    } else {
                        item = right.find((item) => getItemId(item) === getItemId(newSelectedItems[i]));
                    }
                    if (currentIndex === -1) {
                        newChecked.push(item);
                    } else {
                        newChecked.splice(currentIndex, 1);
                    }

                }
                setChecked(newChecked);
            }
        }
    };
    const handleMouseUp = () => {
        setSelectionStart(null);
    };

    const handleAllRight = () => {
        dispatch(setState(rightState, right.concat(left)));
        dispatch(setState(leftState, []));
        setRight(right.concat(left));
        setLeft([]);
        if (rightState === "selectedCustsCGs") {
            dispatch(setState("scenarioExternalDataSource", []));
            //dispatch(setState("manually_defineMSList", []));
            dispatch(setState("isCustomerChanged", true));
        }
        if (rightState === "selectedPGs") {
            dispatch(setState("scenarioExternalDataSourceSKU", []));
        }
    };

    const handleCheckedRight = () => {
        dispatch(setState(rightState, right.concat(leftChecked)));
        dispatch(setState(leftState, not(left, leftChecked)));
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
        if (rightState === "selectedCustsCGs") {
            dispatch(setState("scenarioExternalDataSource", []));
            //dispatch(setState("manually_defineMSList", []));
            dispatch(setState("isCustomerChanged", true));
        }
        if (rightState === "selectedPGs") {
            dispatch(setState("scenarioExternalDataSourceSKU", []));
        }
    };

    const handleCheckedLeft = () => {
        dispatch(setState(leftState, left.concat(rightChecked)));
        dispatch(setState(rightState, not(right, rightChecked)));
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
        if (rightState === "selectedCustsCGs") {
            dispatch(setState("scenarioExternalDataSource", []));
            //dispatch(setState("manually_defineMSList", []));
            dispatch(setState("isCustomerChanged", true));
        }
        if (rightState === "selectedPGs") {
            dispatch(setState("scenarioExternalDataSourceSKU", []));
        }
    };

    const handleAllLeft = () => {
        dispatch(setState(leftState, left.concat(right)));
        dispatch(setState(rightState, []));
        setLeft(left.concat(right));
        setRight([]);
        if (rightState === "selectedCustsCGs") {
            dispatch(setState("scenarioExternalDataSource", []));
            //dispatch(setState("manually_defineMSList", []));
            dispatch(setState("isCustomerChanged", true));
        }
        if (rightState === "selectedPGs") {
            dispatch(setState("scenarioExternalDataSourceSKU", []));
        }
    };
    const handleDoubleClick = (item, side) => {
        if (side == "left") {
            dispatch(setState(rightState, right.concat(item)));
            let leftlist = JSON.parse(JSON.stringify(left));
            // for (let i = 0; i < leftlist.length; i++) {
            //     if (getItemId(leftlist[i]) === getItemId(item)) {
            //         leftlist.splice(i, 1);
            //     }
            // }
            leftlist = leftlist.filter(x => getItemId(x) != getItemId(item));
            dispatch(setState(leftState, leftlist));
            setRight(right.concat(item));
            setLeft(leftlist);
            let checkedlist = JSON.parse(JSON.stringify(checked));
            checkedlist = checkedlist.filter(x => getItemId(x) != getItemId(item));
            setChecked(checkedlist);
            if (rightState === "selectedCustsCGs") {
                dispatch(setState("scenarioExternalDataSource", []));
                //dispatch(setState("manually_defineMSList", []));
                dispatch(setState("isCustomerChanged", true));
            }
            if (rightState === "selectedPGs") {
                dispatch(setState("scenarioExternalDataSourceSKU", []));
            }
        }
        if (side == "right") {
            dispatch(setState(leftState, left.concat(item)));
            let rightlist = JSON.parse(JSON.stringify(right));
            // for(let i = 0; i< rightlist.length; i++){
            //  if(getItemId(rightlist[i]) === getItemId(item)){
            //      rightlist.splice(i,1);
            //  }
            // }
            rightlist = rightlist.filter(x => getItemId(x) != getItemId(item));
            dispatch(setState(rightState, rightlist));
            setLeft(left.concat(item));
            setRight(rightlist);
            let checkedlist = JSON.parse(JSON.stringify(checked));
            checkedlist = checkedlist.filter(x => getItemId(x) != getItemId(item));
            setChecked(checkedlist);
            if (rightState === "selectedCustsCGs") {
                dispatch(setState("scenarioExternalDataSource", []));
                //dispatch(setState("manually_defineMSList", []));
                dispatch(setState("isCustomerChanged", true));
            }
            if (rightState === "selectedPGs") {
                dispatch(setState("scenarioExternalDataSourceSKU", []));
            }
        }
    }

    const getItemText = (item) => {
        if (item.hasOwnProperty("name")) {
            return item.name + (item['parentName'] == undefined || item['type'] == 'CG' ? '' : (item['parentName'].indexOf(',') > -1) ? ' ( * )' : ' (' + item['parentName'] + ' )');
        } else if (item.hasOwnProperty("productGroupName")) {
            return item.productGroupName;
        } else if (item.hasOwnProperty("productName")) {
            return item.productName;
        } else if (item.hasOwnProperty("customerGroupName")) {
            return item.customerGroupName;
        } else if (item.hasOwnProperty("customerName")) {
            return item.customerName + (item['parentName'] == undefined ? '' : (item['parentName'].indexOf(',') > -1) ? ' ( * )' : ' (' + item['parentName'] + ' )');
        }
    };
    const getItemTextForToolTip = (item) => {
        if (item.hasOwnProperty("name")) {
            return item.name + (item['parentName'] == undefined || item['type'] == 'CG' ? '' : ' (' + item['parentName'] + ' )');;
        } else if (item.hasOwnProperty("productGroupName")) {
            return item.productGroupName;
        } else if (item.hasOwnProperty("productName")) {
            return item.productName;
        } else if (item.hasOwnProperty("customerGroupName")) {
            return item.customerGroupName;
        } else if (item.hasOwnProperty("customerName")) {
            return item.customerName + (item['parentName'] == undefined ? '' : ' (' + item['parentName'] + ' )');
        }
    };
    const getItemNumber = (item) => {
        if (item.hasOwnProperty("id")) {
            return item.sapCustomerNumber ? item.sapCustomerNumber : item.cip;
        } else if (item.hasOwnProperty("productGroupID")) {
            return 0;
        } else if (item.hasOwnProperty("productID")) {
            return item.clientProductCode;
        } else if (item.hasOwnProperty("customerGroupID")) {
            return 0;
        } else if (item.hasOwnProperty("customerID")) {
            return item.sapCustomerNumber;
        }
    };
    const getItemId = (item) => {
        if (item.hasOwnProperty("productGroupID")) {
            return item.productGroupID;
        } else if (item.hasOwnProperty("productID")) {
            return item.productID;
        } else if (item.hasOwnProperty("customerGroupID")) {
            return item.customerGroupID;
        } else if (item.hasOwnProperty("customerID")) {
            return item.customerID;
        } else if (item.hasOwnProperty("id")) {
            return item.id;
        }
    };
    const handleClick = (type, side) => {
        if (type === "name") {
            if (side === "left") {
                if (!isAscByNameLeft) {
                    let list = JSON.parse(JSON.stringify(left));
                    list = list.sort((a, b) => (getItemText(a).trim() > getItemText(b).trim()) ? 1 : -1);
                    setLeft(list);
                    setAscByNameLeft(true);
                }
                else {
                    let list = JSON.parse(JSON.stringify(left));
                    list = list.sort((a, b) => (getItemText(a).trim() < getItemText(b).trim()) ? 1 : -1);
                    setLeft(list);
                    setAscByNameLeft(false);
                }
            } else {
                if (!isAscByNameRight) {
                    let list = JSON.parse(JSON.stringify(right));
                    list = list.sort((a, b) => (getItemText(a).trim() > getItemText(b).trim()) ? 1 : -1);
                    setAscByNameRight(true);
                    setRight(list);
                }
                else {
                    let list = JSON.parse(JSON.stringify(right));
                    list = list.sort((a, b) => (getItemText(a).trim() < getItemText(b).trim()) ? 1 : -1);
                    setAscByNameRight(false);
                    setRight(list);
                }
            }
        } else {
            if (side === "left") {
                if (!isAscByNumberLeft) {
                    let list = JSON.parse(JSON.stringify(left));
                    list = list.sort((a, b) => (getItemNumber(a) > getItemNumber(b)) ? 1 : -1);
                    setLeft(list);
                    setAscByNumberLeft(true);
                }
                else {
                    let list = JSON.parse(JSON.stringify(left));
                    list = list.sort((a, b) => (getItemNumber(a) < getItemNumber(b)) ? 1 : -1);
                    setLeft(list);
                    setAscByNumberLeft(false);
                }
            } else {
                if (!isAscByNumberRight) {
                    let list = JSON.parse(JSON.stringify(right));
                    list = list.sort((a, b) => (getItemNumber(a) > getItemNumber(b)) ? 1 : -1);
                    setAscByNumberRight(true);
                    setRight(list);
                }
                else {
                    let list = JSON.parse(JSON.stringify(right));
                    list = list.sort((a, b) => (getItemNumber(a) < getItemNumber(b)) ? 1 : -1);
                    setAscByNumberRight(false);
                    setRight(list);
                }
            }
        }
    }

    const customList = (items, count, side) => {
        const isItemLoaded = index => !!items[index];
        return (
            <React.Fragment>
                {side === "right" && isCustomer ? <Typography variant="subtitle1">Customer to be assigned</Typography> : null}
                {side === "right" && !isCustomer ? <Typography variant="subtitle1">Product to be assigned</Typography> : null}
                {side === "left" ? <Typography variant="subtitle1">Search result</Typography> : null}
                <Typography sx={{ fontSize: "14px", cursor: "pointer" }} onClick={() => handleClick("name", side)} display="inline">Sort by Name |</Typography> <Typography sx={{ fontSize: "14px", cursor: "pointer" }} onClick={() => handleClick("number", side)} display="inline">Sort by Number</Typography>
                <Typography sx={{ mt: 1, mb: 1, }} variant="subtitle2" >Count: {count}</Typography>
                <Paper className="transferList"
                    sx={{ width: `${boxWidth}vw`, height: 400, overflowY: "auto", overflowX: "none", justifyContent: "space-between", border: "1px solid #c6c6c6" }}
                >
                    <InfiniteLoader itemCount={items.length} isItemLoaded={isItemLoaded}>
                        {({ onItemsRendered, ref }) => (
                            <AutoSizer>
                                {({ height, width }) => (
                                    <List
                                        ref={ref}
                                        height={395}
                                        width={`${boxWidth - 0.2}vw`}
                                        itemCount={items.length}
                                        itemSize={listHeight}
                                        style={{ overflowY: 'auto', overflowX: 'hidden' }}
                                        onItemsRendered={onItemsRendered}>
                                        {({ index, style }) => {
                                            return (

                                                <ListItem
                                                    key={index}
                                                    item={items[index]}
                                                    style={{ ...style, backgroundColor: checked.includes(items[index]) ? '#f2f1ed' : '' }}
                                                    button
                                                    onClick={(event) => handleToggle(event, index, items[index], side)}
                                                    //onClick={handleClick}
                                                    onDoubleClick={() => handleDoubleClick(items[index], side)}
                                                    //onMouseDown={(e) => handleMouseDown(e, index)}
                                                    onMouseMove={(e) => handleMouseMove(e, side, index)}
                                                    onMouseUp={handleMouseUp}
                                                >
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            checked={checked.indexOf(items[index]) !== -1}
                                                            onClick={(event) => handleToggle(event, index, items[index], side)}
                                                            tabIndex={-1}
                                                            disableRipple
                                                        />
                                                    </ListItemIcon>
                                                    <Tooltip title={getItemTextForToolTip(items[index])}
                                                        sx={{
                                                            '& .MuiTooltip-tooltip': {
                                                                fontSize: '2rem !important',
                                                                padding: '10px 20px',
                                                            },
                                                        }}>
                                                        <ListItemText id={index} primary={getItemText(items[index])}
                                                            className={items[index]?.active === 'N' ? 'red-text' : items[index]?.stqColor === 'Y'
                                                                ? 'blue-text' : ''}
                                                        /></Tooltip>
                                                </ListItem>
                                            );
                                        }}
                                    </List>
                                )}
                            </AutoSizer>
                        )}
                    </InfiniteLoader>
                </Paper>
            </React.Fragment>
        );

    }

    return (
        <Grid fullWidth container spacing={2} justifyContent="space-between" alignItems="center">
            <Grid item>{customList(left, countLeft, "left")}</Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center">
                    <CustomButton
                        sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
                        size="small"
                        onClick={handleAllRight}
                        disabled={left.length === 0}
                        aria-label="move all right"
                    >
                        {addAllBtnText}
                    </CustomButton>
                    <Button
                        sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
                        size="small"
                        onClick={handleCheckedRight}
                        disabled={leftChecked.length === 0}
                        aria-label="move selected right"
                    >
                        {addBtnText}
                    </Button>
                    <Button
                        sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
                        size="small"
                        onClick={handleCheckedLeft}
                        disabled={rightChecked.length === 0}
                        aria-label="move selected left"
                    >
                        {remBtnText}
                    </Button>
                    <Button
                        sx={{ my: 0.5,  
							bgcolor: "grey.lighter",
							color: "#001489",
							width:"100%",
							// height: "40px",
							// fontSize: "14px",
							boxShadow: "none",
							"&:hover": {
							  bgcolor: "#001489",
							  color: "white.main",
							  border:"none",
							},   
						}}
                        size="small"
                        onClick={handleAllLeft}
                        disabled={right.length === 0}
                        aria-label="move all left"
                    >
                        {remAllBtnText}
                    </Button>
                </Grid>
            </Grid>
            <Grid item>{customList(right, countRight, "right")}</Grid>
        </Grid>
    );
}